export const LOCAL_STORAGE_AUTHORIZATION_ERROR_KEY = "authorizationError";
export const DEFAULT_BACKGROUND_ALERT_DURATION = 3000;
export const PROTOCOLO_CONDUTA_LOCAL_STORAGE_STATE_KEY =
  "@abatech-impressao/protocolo_conduta";
export const IMPRIMIR_LOCAL_STORAGE_KEY = "@abatech-impressao";
